<template>
  <div class="pos-home-outer">
  <div class="pos-home-inner">

    <!-- ── ESTADO INICIAL: sin búsqueda activa ── -->
    <div v-if="estadoInicial" class="hero-wrapper">
      <div class="text-center">
        <v-icon size="48" color="grey darken-2">mdi-magnify</v-icon>
        <div class="grey--text caption mt-4">
          Usá el buscador de arriba para encontrar productos
        </div>
      </div>
    </div>

    <!-- ── CON RESULTADOS ── -->
    <div v-else>
      <v-row align="center" class="px-6 pt-4 mb-0" v-if="arqueoCaja">
        <v-spacer />
        <v-col cols="auto" class="py-1">
          <v-btn rounded color="primary" :to="{ name: 'pos.venta.registrar' }" elevation="0" small>
            <v-icon left x-small>mdi-cart-outline</v-icon>
            Nueva venta
          </v-btn>
        </v-col>
      </v-row>

      <PosProductoSearch
        :cards="cards"
        :loading="loadingBusqueda"
        :sinResultados="sinResultados"
        :total="totalResultados"
        :page="page"
        :pageSize="pageSize"
        :query="queryActual"
        @card-click="onCardClick"
        @page-change="onPageChange"
      />
    </div>

  </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ProductosAPI from "@/api/productos";
import PosProductoSearch from "@/views/pos/components/PosProductoSearch.vue";

export default {
  name: "PosHome",
  components: { PosProductoSearch },

  data() {
    return {
      loadingBusqueda: false,
      sinResultados: false,
      cards: [],
      totalResultados: 0,
      page: 1,
      pageSize: 24,
      queryActual: null,
      queryEsBarcode: false,
    };
  },

  computed: {
    ...mapState("sucursales", ["arqueoCaja"]),
    ...mapGetters("sucursales", ["sucursalUuid"]),

    estadoInicial() {
      return !this.loadingBusqueda && !this.sinResultados && !this.cards.length;
    },
  },

  watch: {
    '$route.query': {
      immediate: true,
      handler(query) {
        if (query.barcode) {
          this.buscarProducto(query.barcode, 1, true);
        } else if (query.q) {
          this.buscarProducto(query.q, 1, false);
        } else {
          this.reset();
        }
      },
    },
  },

  methods: {
    reset() {
      this.sinResultados = false;
      this.cards = [];
      this.totalResultados = 0;
      this.page = 1;
      this.queryActual = null;
    },

    async buscarProducto(query, page = 1, isBarcode = false) {
      this.sinResultados = false;
      this.cards = [];
      this.loadingBusqueda = true;
      this.page = page;
      this.queryActual = query;
      this.queryEsBarcode = isBarcode;
      try {
        const search = isBarcode ? String(query).trim() : String(query).trim().replace(/\s+/g, "-");
        const response = await ProductosAPI.getPspList(search, this.sucursalUuid, page, this.pageSize, isBarcode);
        const data = response?.data || {};
        const items = data.results || [];
        this.totalResultados = data.count || 0;
        if (!items.length) {
          this.sinResultados = true;
          return;
        }
        this.cards = items.map(item => ({
          psp_id: item.id,
          descripcion: item.descripcion,
          imagen_principal: item.imagen || null,
          precio_venta: item.precio_venta,
          categoria: item.categoria || null,
          loading: false,
        }));
      } catch {
        this.sinResultados = true;
      } finally {
        this.loadingBusqueda = false;
      }
    },

    onPageChange(page) {
      if (this.queryActual) {
        this.buscarProducto(this.queryActual, page, this.queryEsBarcode);
      }
    },

    onCardClick(card) {
      // Extender según necesidad
    },
  },
};
</script>

<style scoped>
.pos-home-outer {
  min-height: 100%;
  background: #141414;
  padding: 24px 16px 48px;
}

.pos-home-inner {
  max-width: 1470px;
  margin: 0 auto;
}

.hero-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 15vh;
}
</style>
